/**
 * El sobre de `agent/v1`: `{ success, data, meta }`.
 *
 * Existe aquí porque ya estaba escrito tres veces —`toolsService`,
 * `agentsService` y `elevenlabsAgentsService` llevan cada uno su copia
 * privada— y dos de ellas no se comportan igual ante una respuesta a medias.
 * Añadir una cuarta era la opción cómoda y la peor: el día que el sobre cambie,
 * hay que acordarse de cuatro sitios.
 *
 * Los tres de antes no se tocan aquí; se quedan dichos para juntarlos cuando
 * alguien pase por ellos.
 */
export function unwrap<T>(response: unknown): T {
  if (
    response &&
    typeof response === 'object' &&
    'success' in response &&
    'data' in response
  ) {
    return (response as { data: T }).data
  }
  return response as T
}
